import { render, staticRenderFns } from "./RfiImportModal.vue?vue&type=template&id=2fd0c584&scoped=true&"
import script from "./RfiImportModal.vue?vue&type=script&lang=js&"
export * from "./RfiImportModal.vue?vue&type=script&lang=js&"
import style0 from "./RfiImportModal.vue?vue&type=style&index=0&id=2fd0c584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd0c584",
  null
  
)

/* nuxt-component-imports */
installComponents(component, {Template: require('/lasso/components/templates/Template.vue').default,RfiSheetSelect: require('/lasso/components/templates/RfiSheetSelect.vue').default,RfiPageSelect: require('/lasso/components/templates/RfiPageSelect.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fd0c584')) {
      api.createRecord('2fd0c584', component.options)
    } else {
      api.reload('2fd0c584', component.options)
    }
    module.hot.accept("./RfiImportModal.vue?vue&type=template&id=2fd0c584&scoped=true&", function () {
      api.rerender('2fd0c584', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/templates/RfiImportModal.vue"
export default component.exports